import { useHomeQuery } from 'views/utils/graphql/graphql';

const REQUEST_COUNT = 4;

export const useHome = () => {
  const [homeResponse, _] = useHomeQuery({
    variables: {
      notificationCount: REQUEST_COUNT,
    },
    // お知らせ詳細と遷移を繰り返す際に毎回ローディングが出るのは邪魔なのでcache-and-network
    requestPolicy: 'cache-and-network',
  });

  return {
    isLoading: homeResponse.fetching,
    allNotificationList: homeResponse?.data?.AllNotificationList?.Data || [],
    allNotificationListMore: REQUEST_COUNT < (homeResponse?.data?.AllNotificationList?.TotalCount ?? 0),
    personalNotificationList: homeResponse?.data?.PersonalNotificationList?.Data || [],
    personalNotificationListMore: REQUEST_COUNT < (homeResponse?.data?.PersonalNotificationList?.TotalCount ?? 0),
  };
};
